/**
 * Utility for managing consistent player colors across charts
 */

// Exactly 8 very distinct colors as requested
export const playerColors = [
  '#FF3030', // red
  '#1E90FF', // blue
  '#32CD32', // green
  '#FFDF00', // yellow
  '#FF8C00', // orange
  '#FF69B4', // pink
  '#A52A2A', // brown
  '#9370DB', // purple
];

/**
 * Get a consistent color for a player based on their ID
 * @param {string} playerId - The player's ID
 * @returns {string} - A hex color code
 */
export const getPlayerColor = (playerId) => {
  // Use playerId to determine color (modulo to handle more players than colors)
  return playerColors[parseInt(playerId) % playerColors.length];
};

const playerColorUtils = {
  getPlayerColor,
  playerColors
};

export default playerColorUtils;
